// extracted by mini-css-extract-plugin
module.exports = {"background":"Background_background__Mjf6W","bgLight":"Background_bgLight__3Y5Ml","bgDark":"Background_bgDark__I52_V","backgroundImage":"Background_backgroundImage__2iFSs"};